import { render, staticRenderFns } from "./Burial.vue?vue&type=template&id=719d3880&"
import script from "./Burial.vue?vue&type=script&lang=js&"
export * from "./Burial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports